import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../contexts/AuthContext";
import { acceptTeamInvite } from "../api/dashboard";

const PENDING_INVITE_KEY = "pending_team_invite_token";

const InviteAcceptGate: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();
    const { user } = useAuth();
    const isAuthenticated = !!user;

    useEffect(() => {
        // No token? Just go to login normally
        if (!token) {
            navigate("/login", { replace: true });
            return;
        }

        // If user is NOT logged in store token & send to login
        if (!isAuthenticated) {
            localStorage.setItem(PENDING_INVITE_KEY, token);
            navigate("/login", { replace: true });
            return;
        }

        // If user is already logged in accept invite immediately
        const accept = async () => {
            try {
                await acceptTeamInvite(token);
                toast.success("Team invitation accepted successfully");
            } catch (e: any) {
                const msg =
                    e?.response?.data?.error ||
        e?.response?.data?.message ||
         e?.response?.data?.detail|| "Failed to accept invitation";
                toast.error(msg);
            } finally {
                localStorage.removeItem(PENDING_INVITE_KEY);
                navigate("/dashboard", { replace: true });
            }
        };

        accept();
    }, [token, isAuthenticated, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center text-sm text-gray-600">
            Processing invitation…
        </div>
    );
};

export default InviteAcceptGate;
